var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumDypIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2766 6.05872L11.2864 6.59515L11.4921 5.49049L10.6758 4.71659L11.791 4.56817L12.2766 3.55469L12.76 4.56817L13.8753 4.71659L13.059 5.49049L13.2646 6.59515L12.2766 6.05872Z",
    fill: "url(#paint0_linear_1379_5797)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M10.6758 4.71659L12.2766 5.07492V3.55469L11.791 4.56817L10.6758 4.71659Z",
    fill: "url(#paint1_radial_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M12.2773 5.07512L13.876 4.7168L13.0597 5.49069L13.2654 6.59535L12.2773 5.07512Z",
    fill: "url(#paint2_linear_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M12.2753 5.07617L11.2852 6.5964L12.2753 6.05998V5.07617Z",
    fill: "url(#paint3_linear_1379_5797)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7237 6.05872L22.7356 6.59515L22.9413 5.49049L22.125 4.71659L23.2403 4.56817L23.7237 3.55469L24.2092 4.56817L25.3245 4.71659L24.5082 5.49049L24.7138 6.59515L23.7237 6.05872Z",
    fill: "url(#paint4_linear_1379_5797)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M22.125 4.71659L23.7237 5.07492V3.55469L23.2403 4.56817L22.125 4.71659Z",
    fill: "url(#paint5_radial_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M23.7227 5.07512L25.3235 4.7168L24.5072 5.49069L24.7128 6.59535L23.7227 5.07512Z",
    fill: "url(#paint6_linear_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M23.7224 5.07617L22.7344 6.5964L23.7224 6.05998V5.07617Z",
    fill: "url(#paint7_linear_1379_5797)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0031 2.50615L17.013 3.04258L17.2186 1.9358L16.4023 1.16191L17.5176 1.01561L18.0031 0L18.4866 1.01561L19.6018 1.16191L18.7855 1.9358L18.9912 3.04258L18.0031 2.50615Z",
    fill: "url(#paint8_linear_1379_5797)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M16.4023 1.16191L18.0031 1.52023V0L17.5176 1.01561L16.4023 1.16191Z",
    fill: "url(#paint9_radial_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18 1.52043L19.5987 1.16211L18.7824 1.93601L18.988 3.04279L18 1.52043Z",
    fill: "url(#paint10_linear_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.0019 1.51953L17.0117 3.04188L18.0019 2.50545V1.51953Z",
    fill: "url(#paint11_linear_1379_5797)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 6.50195V6.59524L19.1094 6.5486L19.1412 6.50195Z",
    fill: "url(#paint12_linear_1379_5797)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9187 32.4509C17.8833 32.4429 17.8486 32.4323 17.8148 32.4191C16.9015 32.092 16.0171 31.6891 15.1708 31.2148C9.50971 28.0492 5.99219 21.9683 5.99219 15.3467V7.71375L6.51589 7.84096C7.75551 8.15051 9.02719 8.31347 10.3048 8.3265C15.0584 8.3265 17.2254 5.80127 17.6261 5.2712C17.6417 5.24758 17.6587 5.22492 17.677 5.20335L18.0417 4.7793L18.3724 5.27968C18.7732 5.80763 20.9401 8.33498 25.6958 8.33498C26.9736 8.32057 28.2453 8.15618 29.4847 7.8452L30.0084 7.71799V15.3509C30.0084 21.9725 26.4909 28.0535 20.8298 31.219C19.9789 31.6968 19.0896 32.1025 18.171 32.4318C18.1426 32.4423 18.1136 32.4508 18.0841 32.4573L18.0014 32.4742L17.9187 32.4509Z",
    fill: "url(#paint13_linear_1379_5797)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5847 8.26945V15.3448C29.5847 21.7416 26.2071 27.7208 20.6244 30.8439C19.7917 31.3071 18.9214 31.6994 18.0229 32.0164L17.9953 32.027L17.9635 32.0164C17.0673 31.6968 16.1998 31.3017 15.3704 30.8354C9.78774 27.7144 6.41016 21.7353 6.41016 15.3384V8.26945C14.1534 10.1183 17.4991 6.14919 17.9698 5.51311L18.0017 5.4707C18.0017 5.48342 18.0186 5.49615 18.0292 5.51311C18.502 6.14919 21.8393 10.1183 29.5847 8.26945Z",
    fill: "url(#paint14_linear_1379_5797)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M8.66797 24.0827C10.23 26.9172 12.5528 29.259 15.3744 30.8442C16.2041 31.3076 17.0715 31.6998 17.9675 32.0167L17.9993 32.0273L18.0205 32.0167C18.9171 31.6966 19.7853 31.3015 20.6157 30.8357C23.4373 29.2505 25.76 26.9087 27.3221 24.0742L8.66797 24.0827Z",
    fill: "url(#paint15_linear_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M29.5847 8.26945V15.3448C29.5847 21.7416 26.2071 27.7208 20.6244 30.8439C19.7917 31.3071 18.9214 31.6994 18.0229 32.0164L17.9953 32.027L17.9635 32.0164C17.0673 31.6968 16.1998 31.3017 15.3704 30.8354C9.78774 27.7144 6.41016 21.7353 6.41016 15.3384V8.26945C14.1534 10.1183 17.4991 6.14919 17.9698 5.51311L18.0017 5.4707C18.0017 5.48342 18.0186 5.49615 18.0292 5.51311C18.502 6.14919 21.8393 10.1183 29.5847 8.26945Z",
    stroke: "url(#paint16_linear_1379_5797)",
    strokeWidth: 0.81,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0019 8.42771C19.5116 9.58961 22.0114 10.8703 25.6985 10.8703C26.2892 10.8694 26.8794 10.8375 27.4668 10.7748V15.344C27.4668 21.0454 24.4475 26.2761 19.59 28.9922C19.0761 29.28 18.5458 29.5377 18.0019 29.7639C17.458 29.5377 16.9278 29.28 16.4138 28.9922C11.5584 26.2761 8.53918 21.0475 8.53918 15.3461V10.7748C9.12654 10.8375 9.71678 10.8694 10.3075 10.8703C13.9925 10.8703 16.4923 9.59809 18.0019 8.42771ZM18.0019 7.33789L17.7327 7.54992C16.3672 8.67366 13.9692 10.0137 10.3117 10.0137C9.59695 10.0117 8.88306 9.96351 8.17449 9.86949L7.69531 9.80588V15.3461C7.69531 21.355 10.8757 26.8677 16.0046 29.7321C16.5999 30.0661 17.2161 30.3614 17.8493 30.6163L18.0062 30.6799L18.1652 30.6163C18.7984 30.3614 19.4145 30.0661 20.0098 29.7321C25.1345 26.8655 28.3191 21.3529 28.3191 15.344V9.81436L27.84 9.87797C27.1314 9.97199 26.4175 10.0201 25.7027 10.0221C22.0389 10.0221 19.6409 8.68214 18.2818 7.5584L18.0125 7.34637L18.0019 7.33789Z",
    fill: "url(#paint17_linear_1379_5797)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 30.2216C17.3843 29.9783 16.7851 29.695 16.2063 29.3735C11.2152 26.5726 8.11328 21.202 8.11328 15.3458V10.2975C8.84011 10.3941 9.57242 10.4437 10.3056 10.4459C14.1115 10.4459 16.6028 9.0359 18.0001 7.88672C19.3973 9.0359 21.8887 10.4459 25.6967 10.4459C26.4299 10.4437 27.1622 10.3941 27.889 10.2975V15.3437C27.889 21.1999 24.7871 26.5705 19.7959 29.3608C19.2163 29.6857 18.6164 29.9732 18.0001 30.2216Z",
    fill: "url(#paint18_radial_1379_5797)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3035 10.871C9.71276 10.8701 9.12252 10.8383 8.53516 10.7756V15.3469C8.53516 21.0483 11.5544 26.2769 16.4098 28.9929C16.9066 29.2704 17.4184 29.5203 17.9428 29.7414V8.46875C16.4289 9.62005 13.944 10.871 10.3035 10.871Z",
    fill: "url(#paint19_radial_1379_5797)",
    style: {
      mixBlendMode: "screen"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.697 10.8703C22.012 10.8703 19.5101 9.59812 18.0004 8.42773L17.9453 8.46802V29.7407L18.0004 29.764C18.5443 29.5377 19.0746 29.28 19.5885 28.9922C24.446 26.2761 27.4653 21.0454 27.4653 15.344V10.7749C26.8779 10.8376 26.2877 10.8694 25.697 10.8703Z",
    fill: "url(#paint20_radial_1379_5797)",
    style: {
      mixBlendMode: "color-dodge"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.0001 30.2216C17.3843 29.9783 16.7851 29.695 16.2063 29.3735C11.2152 26.5726 8.11328 21.202 8.11328 15.3458V10.2975C8.84011 10.3941 9.57242 10.4437 10.3056 10.4459C14.1115 10.4459 16.6028 9.0359 18.0001 7.88672C19.3973 9.0359 21.8887 10.4459 25.6967 10.4459C26.4299 10.4437 27.1622 10.3941 27.889 10.2975V15.3437C27.889 21.1999 24.7871 26.5705 19.7959 29.3608C19.2163 29.6857 18.6164 29.9732 18.0001 30.2216Z",
    stroke: "url(#paint21_linear_1379_5797)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M28.3102 9.81445V15.3441C28.3102 21.3529 25.1298 26.8656 20.0009 29.7322C19.4056 30.0662 18.7894 30.3615 18.1562 30.6164",
    stroke: "url(#paint22_linear_1379_5797)",
    strokeWidth: 0.81,
    strokeMiterlimit: 10
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1081 6.5486L19.0742 6.59524V6.50195C19.0742 6.50195 19.0806 6.51892 19.1081 6.5486Z",
    fill: "url(#paint23_linear_1379_5797)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M9.32771 17.7419C9.26096 17.9367 9.13536 18.106 8.96824 18.2264C8.80113 18.3468 8.60075 18.4124 8.39479 18.414L6.17699 17.9899C6.13035 17.6613 6.09006 17.3305 6.0625 16.9977V16.9871C6.36782 16.6775 8.03859 16.8726 8.03859 16.8726L8.81249 15.6895L8.99059 15.8273L9.32771 17.7419Z",
    fill: "url(#paint24_linear_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M9.85795 20.7162C9.85795 20.7162 9.80494 21.1169 9.25155 21.3522L6.9553 21.2441C6.79699 20.7706 6.65564 20.2914 6.53125 19.8066C6.807 19.7282 7.0927 19.6903 7.37936 19.6942C7.60835 19.7175 9.33 18.8164 9.33 18.8164L9.47842 18.9415L9.85795 20.7162Z",
    fill: "url(#paint25_linear_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M10.1763 22.8311C10.1316 22.9398 10.0634 23.0373 9.9765 23.1165C9.88961 23.1957 9.78624 23.2546 9.67383 23.2891C9.08468 23.3544 8.50039 23.4578 7.92461 23.5986C7.76347 23.2735 7.61151 22.9442 7.46875 22.6106C7.57936 22.4468 7.73092 22.3148 7.90835 22.2278C8.08578 22.1408 8.2829 22.1017 8.48012 22.1144C8.76211 22.1484 9.77348 21.5547 9.77348 21.5547L9.9007 21.6798L10.1763 22.8311Z",
    fill: "url(#paint26_linear_1379_5797)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14471 17.7427L8.81395 15.6797L0 11.8887L0.805701 15.6797L9.14471 17.7427Z",
    fill: "url(#paint27_linear_1379_5797)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33451 18.8176L2.46484 17.2168L3.04792 19.9138L9.68223 20.6707L9.33451 18.8176Z",
    fill: "url(#paint28_linear_1379_5797)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77675 21.5537L5.10156 21.2441L5.48533 22.987L10.046 22.7559L9.77675 21.5537Z",
    fill: "url(#paint29_linear_1379_5797)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14369 17.7419C9.06152 17.8684 8.93996 17.9644 8.79778 18.015C8.65561 18.0656 8.50073 18.068 8.35708 18.0217L0.804688 15.6895L9.14369 17.7419Z",
    fill: "url(#paint30_linear_1379_5797)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68119 20.671C9.59208 20.8089 9.46355 20.9168 9.3123 20.9807C9.16105 21.0446 8.99408 21.0616 8.83308 21.0293L3.04688 19.9141L9.68119 20.671Z",
    fill: "url(#paint31_linear_1379_5797)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0451 22.7559C9.96107 22.8544 9.85628 22.9331 9.73822 22.9862C9.62017 23.0394 9.49179 23.0657 9.36234 23.0633L5.48438 22.987L10.0451 22.7559Z",
    fill: "url(#paint32_linear_1379_5797)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M0 11.8887L0.375287 13.6549L8.99205 16.7822L8.81395 15.6797L0 11.8887Z",
    fill: "url(#paint33_radial_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M2.46484 17.2168L9.33451 18.8176L9.48292 19.6148L2.74472 18.5144L2.46484 17.2168Z",
    fill: "url(#paint34_radial_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M5.10156 21.2441L9.77675 21.5537L9.90397 22.1156H5.29451L5.10156 21.2441Z",
    fill: "url(#paint35_radial_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M26.668 17.7419C26.7347 17.9367 26.8603 18.106 27.0274 18.2264C27.1945 18.3468 27.3949 18.4124 27.6009 18.414L29.8187 17.9899C29.8653 17.6613 29.9056 17.3305 29.9332 16.9977V16.9871C29.6279 16.6775 27.9571 16.8726 27.9571 16.8726L27.1874 15.6895L27.0093 15.8273L26.668 17.7419Z",
    fill: "url(#paint36_linear_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M26.1445 20.7162C26.1445 20.7162 26.1975 21.1169 26.7509 21.3522L29.0493 21.2441C29.209 20.7706 29.3504 20.2914 29.4733 19.8066C29.1976 19.7282 28.9119 19.6903 28.6252 19.6942C28.3984 19.7069 26.6704 18.8164 26.6704 18.8164L26.5219 18.9415L26.1445 20.7162Z",
    fill: "url(#paint37_linear_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M25.8125 22.8311C25.8572 22.9398 25.9254 23.0373 26.0123 23.1165C26.0992 23.1957 26.2026 23.2546 26.315 23.2891C26.9041 23.3544 27.4884 23.4578 28.0642 23.5986C28.2254 23.2735 28.3773 22.9442 28.5201 22.6106C28.4098 22.4475 28.259 22.3159 28.0823 22.2289C27.9057 22.1419 27.7095 22.1024 27.513 22.1144C27.231 22.1484 26.2196 21.5547 26.2196 21.5547L26.0924 21.6798L25.8125 22.8311Z",
    fill: "url(#paint38_linear_1379_5797)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8555 17.7427L27.1862 15.6797L36.0002 11.8887L35.1945 15.6797L26.8555 17.7427Z",
    fill: "url(#paint39_linear_1379_5797)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6641 18.8176L33.5338 17.2168L32.9507 19.9138L26.3164 20.6707L26.6641 18.8176Z",
    fill: "url(#paint40_linear_1379_5797)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2224 21.5537L30.8976 21.2441L30.5138 22.987L25.9531 22.7559L26.2224 21.5537Z",
    fill: "url(#paint41_linear_1379_5797)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8555 17.7419C26.9376 17.8684 27.0592 17.9644 27.2014 18.015C27.3436 18.0656 27.4984 18.068 27.6421 18.0217L35.1966 15.6895L26.8555 17.7419Z",
    fill: "url(#paint42_linear_1379_5797)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3164 20.671C26.4057 20.8087 26.5343 20.9164 26.6855 20.9803C26.8367 21.0442 27.0035 21.0613 27.1645 21.0293L32.955 19.9141L26.3164 20.671Z",
    fill: "url(#paint43_linear_1379_5797)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9531 22.7559C26.0371 22.8544 26.1419 22.9331 26.26 22.9862C26.378 23.0394 26.5064 23.0657 26.6358 23.0633L30.5138 22.987L25.9531 22.7559Z",
    fill: "url(#paint44_linear_1379_5797)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M36.0016 11.8887L35.6264 13.6549L27.0117 16.7822L27.1877 15.6797L36.0016 11.8887Z",
    fill: "url(#paint45_radial_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.5337 17.2168L26.664 18.8176L26.5156 19.6148L33.2538 18.5144L33.5337 17.2168Z",
    fill: "url(#paint46_radial_1379_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M30.9001 21.2441L26.2249 21.5537L26.0977 22.1156H30.7071L30.9001 21.2441Z",
    fill: "url(#paint47_radial_1379_5797)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1379_5797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2886 18.859L15.8052 22.2303C15.8123 22.2303 15.8123 22.2374 15.8195 22.2374L17.4944 23.4829C17.6375 23.5902 17.838 23.49 17.838 23.3111L17.8451 14.0275C17.8308 13.8629 17.8093 13.6911 17.7735 13.5265C17.7377 13.369 17.6876 13.2187 17.6161 13.0898C17.7377 13.9989 17.2224 15.0582 16.3491 15.7525C16.1559 15.91 15.8911 16.0818 15.5976 16.2035C15.2826 16.3395 14.3307 16.6687 14.3307 16.6687L11.4604 17.7066C10.9665 17.8855 10.8663 18.544 11.2886 18.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7746 16.1266C15.7818 16.1194 15.7961 16.1194 15.8033 16.1123C15.8176 16.1051 15.8319 16.0979 15.8534 16.0836C15.8748 16.0765 15.8892 16.0621 15.9106 16.055C15.9178 16.0478 15.9321 16.0407 15.9393 16.0407C15.9607 16.0264 15.9894 16.012 16.0108 15.9977C16.018 15.9906 16.0252 15.9906 16.0323 15.9834C16.0538 15.9691 16.0753 15.9548 16.1039 15.9405C16.1182 15.9333 16.1254 15.9262 16.1397 15.919C16.154 15.9047 16.1755 15.8975 16.1898 15.8832C16.2113 15.8689 16.2327 15.8474 16.2614 15.8331C16.2685 15.8331 16.2685 15.8259 16.2757 15.8259C16.3043 15.8045 16.3329 15.783 16.3616 15.7615C17.2348 15.0672 17.7502 14.0079 17.6285 13.0988C17.5784 13.013 17.514 12.9342 17.4424 12.877L15.9536 11.7747C15.8104 11.6673 15.6029 11.7675 15.6029 11.9465V14.5447C15.6029 16.1767 14.3359 16.6706 14.3359 16.6706C14.3359 16.6706 15.2951 16.3485 15.6029 16.2125C15.6601 16.1838 15.7174 16.1552 15.7746 16.1266Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0884 18.5216L20.5719 15.1503C20.5647 15.1503 20.5647 15.1432 20.5575 15.1432L18.8826 13.8977C18.7395 13.7904 18.5391 13.8906 18.5391 14.0695V23.3531C18.5534 23.5177 18.5749 23.6895 18.6106 23.8541C18.6464 24.0116 18.6965 24.1619 18.7681 24.2907C18.6464 23.3817 19.1618 22.3224 20.035 21.6281C20.2283 21.4706 20.4931 21.2988 20.7866 21.1771C21.0944 21.0411 22.0535 20.719 22.0535 20.719L24.9238 19.6812C25.4176 19.4951 25.5107 18.8366 25.0884 18.5216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6176 21.2569C20.6105 21.264 20.5962 21.264 20.589 21.2712C20.5747 21.2784 20.5604 21.2855 20.5389 21.2998C20.5174 21.307 20.5031 21.3213 20.4816 21.3285C20.4745 21.3356 20.4602 21.3428 20.453 21.3428C20.4315 21.3571 20.4029 21.3714 20.3814 21.3857C20.3743 21.3929 20.3671 21.3929 20.36 21.4C20.3385 21.4143 20.317 21.4287 20.2884 21.443C20.2741 21.4501 20.2669 21.4573 20.2526 21.4645C20.2383 21.4788 20.2168 21.4859 20.2025 21.5002C20.181 21.5146 20.1595 21.536 20.1309 21.5503C20.1237 21.5503 20.1237 21.5575 20.1166 21.5575C20.088 21.579 20.0593 21.6004 20.0307 21.6219C19.1575 22.3162 18.6421 23.3756 18.7638 24.2846C18.8139 24.3705 18.8783 24.4492 18.9499 24.5065L20.4315 25.6088C20.5747 25.7161 20.7823 25.6159 20.7823 25.437V22.8387C20.7823 21.2139 22.0492 20.7129 22.0492 20.7129C22.0492 20.7129 21.09 21.035 20.7823 21.171C20.7322 21.1996 20.6749 21.2282 20.6176 21.2569Z",
    fill: "#EBEBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1379_5797",
    x: 7.02344,
    y: 11.7305,
    width: 22.332,
    height: 21.9219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.337255 0 0 0 0 0.976471 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1379_5797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1379_5797",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1379_5797",
    x1: 11.6193,
    y1: 4.08687,
    x2: 12.9699,
    y2: 6.29195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.7932 3.80064) scale(2.65457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F6EEE7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6EEE7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7F0E9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F1EB",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F8F1EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1379_5797",
    x1: 14.3573,
    y1: 6.84978,
    x2: 12.6145,
    y2: 4.20581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E7C883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D2A669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C38D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BA7E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1379_5797",
    x1: 11.5778,
    y1: 7.15403,
    x2: 12.5298,
    y2: 3.26546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E7C883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D2A669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C38D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BA7E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1379_5797",
    x1: 23.0685,
    y1: 4.08687,
    x2: 24.4191,
    y2: 6.29195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2403 3.80064) scale(2.65457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F6EEE7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6EEE7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7F0E9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F1EB",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F8F1EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1379_5797",
    x1: 25.8026,
    y1: 6.84978,
    x2: 24.0619,
    y2: 4.20581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E7C883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D2A669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C38D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BA7E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1379_5797",
    x1: 23.027,
    y1: 7.15403,
    x2: 23.979,
    y2: 3.26546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E7C883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D2A669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C38D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BA7E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1379_5797",
    x1: 17.3459,
    y1: 0.532187,
    x2: 18.6965,
    y2: 2.73726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5197 0.245951) scale(2.65457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F6EEE7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6EEE7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7F0E9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F1EB",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F8F1EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1379_5797",
    x1: 20.0779,
    y1: 3.2951,
    x2: 18.3371,
    y2: 0.651125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E7C883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D2A669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C38D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BA7E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1379_5797",
    x1: 17.3043,
    y1: 3.59739,
    x2: 18.2563,
    y2: -0.291176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E7C883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D2A669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C38D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BA7E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1379_5797",
    x1: 19.1094,
    y1: 6.5486,
    x2: 19.1412,
    y2: 6.5486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1379_5797",
    x1: 5.99219,
    y1: 18.6183,
    x2: 30.0084,
    y2: 18.6183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F2DC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E0BE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D1A468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C59159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BD834E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B87B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#BF8148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E0A24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1379_5797",
    x1: 6.41652,
    y1: 18.7563,
    x2: 29.5847,
    y2: 18.7563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1379_5797",
    x1: 17.9971,
    y1: 31.2386,
    x2: 17.9971,
    y2: 23.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1379_5797",
    x1: 6.33171,
    y1: 18.7287,
    x2: 29.6695,
    y2: 18.7287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1379_5797",
    x1: 7.69107,
    y1: 19.0078,
    x2: 28.3149,
    y2: 19.0078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#EBAC4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3A54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D59A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C28A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A9753D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#875934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0022 19.0542) scale(10.5462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#070D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#070D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070D27"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.4004 9.63278) scale(17.2674 17.2674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAF7F3",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F9F6F2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F8F4EF",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F6F2EB",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F0E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1679 17.3329) scale(10.7837)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E1A54C",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C28E42",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#906931",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4B361A",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23180D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1379_5797",
    x1: 8.06027,
    y1: 19.0478,
    x2: 27.942,
    y2: 19.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E2A54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C68E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#996839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#875934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8A5D37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A98454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C4A66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D9C180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EAD790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F6E69B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FDEEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1379_5797",
    x1: 18.1223,
    y1: 20.2546,
    x2: 28.395,
    y2: 20.2546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1379_5797",
    x1: 19.0742,
    y1: 6.5486,
    x2: 19.1081,
    y2: 6.5486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1379_5797",
    x1: 6.06462,
    y1: 17.0464,
    x2: 9.33195,
    y2: 17.0464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B77946",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B77946",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B77946",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#B77946",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B77946",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B77946",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1379_5797",
    x1: 6.53549,
    y1: 20.0864,
    x2: 9.85795,
    y2: 20.0864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B77946",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B77946",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B77946",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#B77946",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B77946",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B77946",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1379_5797",
    x1: 7.47511,
    y1: 22.5767,
    x2: 10.1848,
    y2: 22.5767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B77946",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B77946",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B77946",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#B77946",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B77946",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B77946",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1379_5797",
    x1: 2.52312,
    y1: 12.9085,
    x2: 11.301,
    y2: 23.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1379_5797",
    x1: 2.12772,
    y1: 14.8612,
    x2: 10.7402,
    y2: 24.4087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1379_5797",
    x1: 5.32843,
    y1: 19.2129,
    x2: 10.6397,
    y2: 26.2607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1379_5797",
    x1: 0.804688,
    y1: 16.8704,
    x2: 9.14369,
    y2: 16.8704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F2DC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E0BE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D1A468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C59159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BD834E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B87B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#BF8148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E0A24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1379_5797",
    x1: 3.04688,
    y1: 20.4781,
    x2: 9.68119,
    y2: 20.4781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F2DC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E0BE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D1A468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C59159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BD834E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B87B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#BF8148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E0A24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1379_5797",
    x1: 5.48438,
    y1: 22.9085,
    x2: 10.0451,
    y2: 22.9085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F2DC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E0BE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D1A468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C59159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BD834E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B87B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#BF8148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E0A24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613F1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.49496 14.29) scale(3.43271 4.56551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F6EEE7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6EEE7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7F0E9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F1EB",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F8F1EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.97388 18.362) scale(2.56128 3.40651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F6EEE7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6EEE7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7F0E9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F1EB",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F8F1EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.5017 21.6178) scale(1.71318 2.27852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F6EEE7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6EEE7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7F0E9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F1EB",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F8F1EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1379_5797",
    x1: 29.9353,
    y1: 17.0464,
    x2: 26.668,
    y2: 17.0464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B77946",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B77946",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B77946",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#B77946",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B77946",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B77946",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1379_5797",
    x1: 29.467,
    y1: 20.0864,
    x2: 26.1445,
    y2: 20.0864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B77946",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B77946",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B77946",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#B77946",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B77946",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B77946",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1379_5797",
    x1: 28.5222,
    y1: 22.5767,
    x2: 25.8125,
    y2: 22.5767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B77946",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B77946",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B77946",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#B77946",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B77946",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B77946",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1379_5797",
    x1: 33.4771,
    y1: 12.9085,
    x2: 24.6992,
    y2: 23.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1379_5797",
    x1: 33.8709,
    y1: 14.8612,
    x2: 25.2584,
    y2: 24.4087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1379_5797",
    x1: 30.6707,
    y1: 19.2129,
    x2: 25.3594,
    y2: 26.2607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFE794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FBDA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F5C76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEB153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEB052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F2C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FCE594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F7E398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E1BF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BE844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1379_5797",
    x1: 35.1945,
    y1: 16.8704,
    x2: 26.8555,
    y2: 16.8704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F2DC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E0BE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D1A468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C59159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BD834E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B87B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#BF8148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E0A24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1379_5797",
    x1: 32.9507,
    y1: 20.4781,
    x2: 26.3164,
    y2: 20.4781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F2DC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E0BE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D1A468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C59159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BD834E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B87B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#BF8148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E0A24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1379_5797",
    x1: 30.5138,
    y1: 22.9085,
    x2: 25.9531,
    y2: 22.9085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFF1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F2DC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E0BE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D1A468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C59159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BD834E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B87B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#BF8148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E0A24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EDAE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613F1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5067 14.29) rotate(180) scale(3.43271 4.56551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F6EEE7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6EEE7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7F0E9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F1EB",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F8F1EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0247 18.362) rotate(180) scale(2.56128 3.40651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F6EEE7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6EEE7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7F0E9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F1EB",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F8F1EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_1379_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4999 21.6178) rotate(180) scale(1.71317 2.27852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F6EEE7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F6EEE7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7F0E9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F8F1EB",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F8F1EB",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumDypIcon);
export default __webpack_public_path__ + "static/media/premiumDypIcon.55f2b3f3171bda049379c8fe6c27815c.svg";
export { ForwardRef as ReactComponent };